var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:(_vm.styleClass + " material-icons"),style:(_vm.iconStyle),attrs:{"title":_vm.title,"role":_vm.isButton? 'button' : ''}},[_vm._v("\n\t"+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }